module.exports = __webpack_public_path__ + "static/img/data1.5da4e3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhsh/data1.png
// module id = qx6y
// module chunks = 13